module.exports = __webpack_public_path__ + "img/credit_card.c086cc5d.svg";